var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.fromData.title,
            visible: _vm.dialogVisible,
            width: _vm.fromData.width,
            "before-close": _vm.handleClose,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "body" }, [
            _c(
              "div",
              { staticClass: "mt14 el-input--small flex" },
              [
                _c("span", { staticClass: "label" }, [_vm._v("接手人员：")]),
                _vm._v(" "),
                _c("select-member", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    "only-one": true,
                    value: _vm.userList || [],
                    placeholder: "请选择企业成员",
                  },
                  on: { getSelectList: _vm.getSelectList },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt20" },
              [
                _c(
                  "el-checkbox-group",
                  {
                    model: {
                      value: _vm.checkList,
                      callback: function ($$v) {
                        _vm.checkList = $$v
                      },
                      expression: "checkList",
                    },
                  },
                  _vm._l(_vm.transfer, function (item) {
                    return _c(
                      "el-checkbox",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.fromData.type <= item.value,
                            expression: "fromData.type <= item.value",
                          },
                        ],
                        key: item.value,
                        attrs: {
                          disabled: _vm.fromData.type === item.value,
                          label: item.value,
                        },
                      },
                      [_vm._v(_vm._s(item.label))]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.handleClose } },
                [_vm._v(_vm._s(_vm.$t("public.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    loading: _vm.loading,
                    size: "small",
                    type: "primary",
                  },
                  on: { click: _vm.handleAdd },
                },
                [_vm._v(_vm._s(_vm.$t("public.ok")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }